export const main = {
  heroSection: {
    title: 'Scale up the quality GameScale',
    button: 'Explore Our Services',
    link: 'https://developers.gamescale.io/en/services',
  },
}
